import { render, staticRenderFns } from "./case-division-import-detail.vue?vue&type=template&id=fe7646f2&scoped=true"
import script from "./case-division-import-detail.vue?vue&type=script&lang=ts"
export * from "./case-division-import-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7646f2",
  null
  
)

export default component.exports